"use client";

import React, { useState } from "react";

interface FAQItem {
  question: string;
  answer: string;
}

interface FAQProps {
  title: string;
  faqs: FAQItem[];
}

const FAQ: React.FC<FAQProps> = ({ title, faqs }) => {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section
      className="w-full py-8 sm:py-12 bg-gradient-to-b from-white to-gray-50"
      itemScope
      itemType="https://schema.org/FAQPage"
    >
      <div className="max-w-6xl mx-auto px-4 sm:px-8 md:px-12">
        <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 text-center pb-8 after:content-[''] after:block after:w-[200px] after:h-[3px] after:mx-auto after:mt-4 after:bg-[linear-gradient(to_right,#AE7D2F_0%,#ECD05B_50%,#AE7D2F_100%)]">
          {title}
        </h2>
        <div className="space-y-6">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="rounded-lg border border-gray-200 bg-white shadow-sm hover:shadow-md transition-shadow duration-300 group"
              itemScope
              itemProp="mainEntity"
              itemType="https://schema.org/Question"
            >
              <div
                className="flex justify-between items-center px-6 py-4 cursor-pointer hover:bg-gray-50 transition-colors duration-300"
                onClick={() => toggleFAQ(index)}
                itemProp="name"
              >
                <h3 className="text-lg sm:text-xl font-semibold text-gray-800 group-hover:bg-gradient-to-r group-hover:from-[#AE7D2F] group-hover:via-[#ECD05B] group-hover:to-[#AE7D2F] group-hover:bg-clip-text group-hover:text-transparent transition-all duration-300">
                  {faq.question}
                </h3>
                <span className="text-xl font-bold text-gray-600 group-hover:text-[#AE7D2F] transition-colors duration-300">
                  {openIndex === index ? "−" : "+"}
                </span>
              </div>
              <div
                className={`max-h-0 transition-max-height duration-300 ease-in-out overflow-hidden ${
                  openIndex === index ? "max-h-full" : ""
                }`}
                itemScope
                itemProp="acceptedAnswer"
                itemType="https://schema.org/Answer"
              >
                <p className="text-gray-700 text-base sm:text-lg leading-relaxed px-6 py-4" itemProp="text">
                  {faq.answer}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQ;